module.exports = __webpack_public_path__ + "img/baner-12.webp";